import { jsx, css } from '@emotion/react';
import { TypographyPDL, Colors } from '@zapier/design-system';
import { useContext, useState, useRef, useEffect } from 'react';
import { TooltipTrigger, TooltipTriggerStateContext, Tooltip as Tooltip$1 } from 'react-aria-components';
import { FocusableTrigger } from './FocusableTrigger.es.js';

const LINE_HEIGHT = 24;
const PADDING_Y = 2;
const SINGLE_LINE_HEIGHT = LINE_HEIGHT + PADDING_Y * 2;
const TooltipStyles = ({ allowMultiline, isMultiline }) => css([
  TypographyPDL("--zds-body-1", "paragraph3Semibold"),
  {
    background: `var(--zds-gray-warm-10, ${Colors.neutral800})`,
    borderRadius: "var(--zds-radius-medium, 100px)",
    color: `var(--zds-gray-warm-1, ${Colors.neutral100})`,
    padding: `var(--zds-space-2, 2px) var(--zds-space-12, 11px)`,
    width: "max-content",
    maxWidth: "300px"
  },
  // Truncates tooltip to a single line if tooltip isn't allowed to span multiple lines
  !allowMultiline && {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  // Applies multi-line styles only if content actually spans multiple lines
  isMultiline && Object.assign(Object.assign({}, TypographyPDL("--zds-body-1-multiline", "paragraph3Semibold")), { borderRadius: "var(--zds-radius-medium, 10px)", padding: "var(--zds-space-4, 16px) var(--zds-space-8, 14px)" })
]);
const TOOLTIP_PLACEMENTS = [
  "bottom",
  "bottom left",
  "bottom right",
  "top",
  "top left",
  "top right",
  "left",
  "left top",
  "left bottom",
  "right",
  "right top",
  "right bottom"
];
const OFFSET_VALUES = {
  small: 4,
  medium: 8,
  large: 12
};
const getOffsetValue = (offset = "medium") => {
  if (typeof offset === "number") {
    return offset;
  }
  return OFFSET_VALUES[offset];
};
const Tooltip = ({ allowMultiline = false, children, content, isOpen, offset = "medium", onOpenChange, placement = "bottom" }) => {
  return jsx(
    TooltipTrigger,
    { closeDelay: 200, delay: 200, isOpen, onOpenChange },
    children,
    jsx(TooltipContent, { allowMultiline, content, offset, placement })
  );
};
const TooltipContent = ({ allowMultiline, content, offset, placement }) => {
  const { isOpen } = useContext(TooltipTriggerStateContext);
  const [isMultiline, setIsMultiLine] = useState(allowMultiline);
  const tooltipRef = useRef(null);
  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.getBoundingClientRect().height;
      const isMultiLine = tooltipHeight > SINGLE_LINE_HEIGHT;
      setIsMultiLine(isMultiLine);
    }
  }, [isOpen]);
  return jsx(Tooltip$1, { css: TooltipStyles({ allowMultiline, isMultiline }), "data-zds": true, offset: getOffsetValue(offset), placement, ref: tooltipRef }, content);
};
Tooltip.FocusableTrigger = FocusableTrigger;

export { TOOLTIP_PLACEMENTS, Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.es.js.map
